import {IBaseEntity, BaseEntity} from 'app/blocks/model/base-entity.model';
import {ILocationPoint, LocationPoint} from 'app/blocks/model/location-point/location-point.model';

export interface IShippingLineLocationPoint extends IBaseEntity {
    id?: number;
    shippingLineId?: number;
    locationPointId?: number;
    locationPoint?: ILocationPoint;
    shippingMode?: string;
    sequenceOrder?: number;
}

export class ShippingLineLocationPoint extends BaseEntity implements IShippingLineLocationPoint {
    public id?: number;
    public shippingLineId?: number;
    public locationPointId?: number;
    public locationPoint?: ILocationPoint;
    public shippingMode?: string;
    public sequenceOrder?: number;

    constructor(shippingLineLocationPoint?) {
        super();
        if (shippingLineLocationPoint) {
            this.id = shippingLineLocationPoint.id;
            this.shippingLineId = shippingLineLocationPoint.shippingLineId;
            this.locationPointId = shippingLineLocationPoint.locationPointId;
            this.locationPoint = shippingLineLocationPoint.locationPoint ? new LocationPoint(shippingLineLocationPoint.locationPoint) : null;
            this.shippingMode = shippingLineLocationPoint.shippingMode;
            this.sequenceOrder = shippingLineLocationPoint.sequenceOrder;
        }
    }

    get discriminator(): any {
        return this.id;
    }

    clone(): IShippingLineLocationPoint {
        return new ShippingLineLocationPoint(this);
    }
}
